var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3753_948)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.0703,
    y: 2.00003,
    width: 47.0703,
    height: 47.0703,
    rx: 10,
    transform: "rotate(90 51.0703 2.00003)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1509 12.1655C27.0728 12.2143 24.3785 14.7727 21.1716 17.8534C16.5297 22.3061 15.3095 23.4974 15.207 23.6976C15.0947 23.9027 15.0703 24.0101 15.0703 24.2981C15.0703 24.7327 15.2119 25.0646 15.5145 25.3185C15.8464 25.6017 16.0612 25.6456 17.2033 25.6456H18.1942V30.7477C18.1942 35.796 18.1942 35.8497 18.2967 36.1183C18.4334 36.4795 18.7848 36.8311 19.146 36.9678C19.4096 37.0654 19.5023 37.0703 21.9428 37.0703C24.359 37.0703 24.4712 37.0654 24.6079 36.9727C24.6909 36.9238 24.8031 36.7969 24.8666 36.6944L24.9789 36.5088V32.9887C24.9789 30.03 24.9886 29.4588 25.0472 29.3758C25.1155 29.2879 25.1985 29.283 27.5658 29.283C29.9331 29.283 30.0161 29.2879 30.0844 29.3758C30.143 29.4588 30.1528 30.03 30.1528 32.9838V36.4942L30.2601 36.6895C30.3187 36.792 30.4407 36.9238 30.5237 36.9775C30.675 37.0703 30.7629 37.0703 33.262 37.0605L35.8392 37.0459L36.0832 36.9238C36.4152 36.7627 36.7129 36.4405 36.8349 36.1134C36.9374 35.8497 36.9374 35.7765 36.9374 30.7477V25.6554L38.0259 25.6359C39.2218 25.6164 39.2999 25.6017 39.6464 25.299C40.0711 24.9231 40.198 24.2054 39.9295 23.6976C39.8221 23.4974 38.6068 22.311 33.96 17.8534C30.7531 14.7727 28.0637 12.2143 27.9807 12.1655C27.7806 12.0386 27.351 12.0386 27.1509 12.1655Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3753_948",
    x: 0,
    y: 0.0000305176,
    width: 55.0703,
    height: 55.0703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3753_948"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3753_948",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.bd6534e64c82539f8c7099ebfc267cb8.svg";
export { ForwardRef as ReactComponent };